const dayOfYear = date =>
  Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
var optionch = {
series: [
],
noData:{
	text: 'Wählen Sie einen  Standort aus ...',
},
          chart: {
          id: 'quantiles',
          type: 'line',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          }
        },
        annotations: {
          yaxis: [
		  {
            y: 0.20,
            borderColor: '#c8642d',
			strokeDashArray: 0,
            label: {
              show: true,
              text: 'sehr trocken',
              style: {
                color: "#000",
                background: '#c8642d'
              }
            }
          },{
            y: 0.4,
            borderColor: '#fac83c',
			strokeDashArray: 0,
            label: {
              show: true,
              text: 'trocken',
              style: {
                color: "#000",
                background: '#fac83c'
              }
            }
          },
		  {
            y: 1,
            borderColor: '#82d732',
			strokeDashArray: 0,
            label: {
              show: true,
              text: 'normal',
              style: {
                color: "#000",
                background: '#82d732'
              }
            }
          }],
          xaxis: [{
            x: dayOfYear(new Date()),//new Date('14 Nov 2012').getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'heute ist der '+new Date().getDate()+'.'+(new Date().getMonth()+1)+'.'+new Date().getFullYear(),//+ ' '+dayOfYear(new Date()),
              style: {
                color: "#fff",
                background: '#775DD0'
              }
            }
          },]
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
		title: {
		  text: 'Füllstand Bodenwasser (REW) mittlerer Verlauf der letzten 10 Jahre und aktuell',
		  align: 'center',
		  style: {
				fontSize:  '12px',
				fontWeight:  'bold',
				//fontFamily:  undefined,
				//color:  '#263238'
			},
		},
        xaxis: {
         // type: 'datetime',
		 type: 'category',
          //min: 0,
          tickAmount: 12,
		  //categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
		  labels: {
            formatter: function(val) {
				if(val<=31)
					return 'Jan';
				if(val<=31+29)
					return 'Feb';
				if(val<=31+29+31)
					return 'Mär';
				if(val<=31+29+31+30)
					return 'Apr';
				if(val<=31+29+31+30+31)
					return 'Mai';
				if(val<=31+29+31+30+31+30)
					return 'Jun';
				if(val<=31+29+31+30+31+30+31)
					return 'Jul';
				if(val<=31+29+31+30+31+30+31+31)
					return 'Aug';
				if(val<=31+29+31+30+31+30+31+31+30)
					return 'Sep';
				if(val<=31+29+31+30+31+30+31+31+30+31)
					return 'Okt';
				if(val<=31+29+31+30+31+30+31+31+30+31+30)
					return 'Nov';
				if(val<=31+29+31+30+31+30+31+31+30+31+30+31)
					return 'Dez';
				
				
            }
          },
		  title: { text: "Tag des Jahres"},
        },
		yaxis: {
			title: {text: "Füllstand Bodenwasser (REW)"},
			min:0,
			max:1.5,
		},
		
        tooltip: {
          x: {
            format: 'dd MMM yyyy'
          }
        },
        fill: {
			type: 'solid',
			opacity: 1,
		},
		stroke: {
			show: true,
			width: 2,},
        };

var ctx = document.getElementById("charti");

var myChart = new ApexCharts(ctx,optionch);
		
myChart.render();
